"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var availableTrialsAdapter = function availableTrialsAdapter(availableTrials) {
  return availableTrials.map(function (trial) {
    var firstTrialParcel = trial.parcels && trial.parcels.length ? trial.parcels[0] : null;
    return {
      name: trial.name,
      trialId: trial.id,
      merchandiseId: firstTrialParcel && firstTrialParcel.merchandiseId || null
    };
  });
};

var _default = availableTrialsAdapter;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/adapters/availableTrialsAdapter.js
// module id = 675
// module chunks = 5 6